<template>
  <el-dialog
    ref="cigDialog"
    :custom-class="
      'cig-dialog' +
      (scrollBorder ? ' scroll-dialog' : '') +
      ' ' +
      ($attrs.class ? $attrs.class : '')
    "
    :append-to-body="attrs.appendToBody || true"
    :model-value="modelValue"
    :show-close="false"
    destroy-on-close
    v-bind="attrs"
    @close="close"
  >
    <template #header>
      <slot name="title">
        <span class="el-dialog__title">{{ title }}</span>
      </slot>
    </template>
    <slot />
    <template #footer>
      <slot name="footer">
        <span>
          <el-button @click="close">{{
            cancelTitle || t('el.popconfirm.cancelButtonText')
          }}</el-button>
          <el-button type="primary" :loading="loading" @click="ok">{{
            okTitle || t('el.popconfirm.confirmButtonText')
          }}</el-button>
        </span>
      </slot>
    </template>
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { ElDialog } from '@park-ui/components/dialog'
import { ElButton } from '@park-ui/components/button'
import { useLocale } from '@park-ui/hooks'

export default defineComponent({
  name: 'ElCigDialog',
  components: {
    ElDialog,
    ElButton,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    cancelTitle: {
      type: String,
    },
    okTitle: {
      type: String,
    },
    title: {
      type: String,
    },
    onCancel: {
      type: Function,
    },
    scrollBorder: {
      type: Boolean,
    },
  },
  emits: ['update:modelValue', 'onClose', 'ok'],
  setup(props, { attrs, emit }) {
    const { t } = useLocale()
    // init here
    const loading = ref(false)
    function close() {
      if (!props.onCancel) {
        emit('update:modelValue', false)
        emit('onClose')
      }
      props.onCancel && props.onCancel()
    }
    function ok() {
      loading.value = true
      emit('ok')
      setTimeout(() => {
        loading.value = false // 1.5秒后自动释放按钮loading
      }, 1500) // 只限制1.5秒防止连续点击,
    }
    watch(
      () => props.modelValue,
      (newV) => {
        if (!newV && loading.value) {
          // 如果外部设置了false and loading = true 需要重置按钮状态
          loading.value = false
        }
      }
    )

    return {
      attrs,
      t,
      ok,
      close,
      loading,
    }
  },
})
</script>
